import React from "react";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { Clock } from "lucide-react";

function AwaitingRole() {
  const { logout } = useAuth();
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B132B] p-6" data-testid="awaiting-role">
      <div className="max-w-md w-full bg-white rounded-2xl border border-slate-200 shadow-xl p-8 text-center">
        <div className="mx-auto h-14 w-14 rounded-full bg-amber-50 border border-amber-100 flex items-center justify-center text-amber-500">
          <Clock className="h-7 w-7" />
        </div>
        <h2 className="font-heading text-2xl font-bold text-slate-900 mt-5">Awaiting role assignment</h2>
        <p className="text-sm text-slate-500 mt-2 leading-relaxed">
          Your account is activated. The CEO has been notified and will assign your role shortly.
          Once a role is assigned, you will have full access. Please check back later.
        </p>
        <Button data-testid="awaiting-signout" onClick={logout} variant="outline" className="mt-6">
          Sign out
        </Button>
      </div>
    </div>
  );
}

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0B132B]">
        <div className="text-slate-300 animate-pulse font-heading text-lg">Loading STEMS…</div>
      </div>
    );
  }
  if (user === false) {
    window.location.replace("/login");
    return null;
  }
  // Verified but no role yet (status pending) — full access is granted only after
  // the CEO assigns a role.
  if (user.status !== "active" || !user.role) {
    return <AwaitingRole />;
  }
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="p-10">
        <h2 className="text-2xl font-heading font-bold text-slate-900">Access restricted</h2>
        <p className="text-slate-500 mt-2">You do not have permission to view this page.</p>
      </div>
    );
  }
  return children;
}
